var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('VueSlickCarousel',_vm._b({staticClass:"members-cards"},'VueSlickCarousel',_vm.settings,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }